import React, { useState, useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import { Button, Form } from "react-bootstrap";
import FormHeading from "../common/FormHeading";
import SelectDropdown from "../../components-react/SelectDropdown";
import {
  createNewCTO,
  uploadCreatCtoFile,
} from "../../../redux/reducers/postApiSlice";
import { fetchCTOData, fetchCTOHead } from "../../../redux/reducers/apiSlice";
import { ctoTypes } from "../../../exports/ProfitShareData";
import { fetchGymData } from "../../../data/APIs";
import { selectGymData } from "../../../redux/reducers/gymDataSlice";
import { toast } from "react-toastify";
import { selectAuth } from "../../auth/auth.selector";

function CreateNewCTO({ queryParameters, onClose }) {
  const dispatch = useDispatch();
  const userInfo = useSelector(selectAuth);
  const [decryptedText, setDecryptedText] = useState(userInfo?.user || {});

  const { ctoHeadData } = useSelector((state) => state.api);
  const selectedGym = useSelector((state) => state.filters.selectedGym);

  const gymData = useSelector(selectGymData);

  const [selectedGymFromDropdown, setSelectedGymFromDropdown] = useState("");
  const [allCtoHeads, setAllCtoHeads] = useState([]);
  const initialFormInputs = [
    {
      type: "",
      ctoHead: "",
      ctoCost: "",
      selectedFiles: "",
    },
  ];
  const [formInputs, setFormInputs] = useState(initialFormInputs);

  const addMoreInputs = (e) => {
    e.preventDefault();
    setFormInputs([...formInputs, { type: "", ctoHead: "", ctoCost: "" }]);
  };

  const removeInputs = (e, index) => {
    e.preventDefault();
    const updatedInputs = [...formInputs];
    updatedInputs.splice(index, 1);
    setFormInputs(updatedInputs);
  };

  const handleInputChange = async (index, field, value, authToken) => {
    if (field === "file") {
      const fileData = new FormData();
      fileData.append("media", value);

      try {
        const response = await dispatch(
          uploadCreatCtoFile({ fileData, authToken })
        );
        if (uploadCreatCtoFile.fulfilled.match(response)) {
          const { data } = response.payload;
          handleInputFileChange(index, data);

          const successMessage = response.payload.message;
          toast.success(successMessage);

          onSubmitCtoDetails();
        } else {
          const errorMessage = response.error.message;
          toast.error(errorMessage);
        }
      } catch (error) {
        console.error("File upload error:", error);
      }
    } else {
      const updatedInputs = [...formInputs];
      updatedInputs[index][field] = value;
      setFormInputs(updatedInputs);
    }
  };

  const onSubmitCtoDetails = (e) => {
    e.preventDefault();

    const currentDate = new Date();
    const currentYear = currentDate.getFullYear();
    const currentMonth = currentDate.getMonth() + 1;

    const ctoDetails = formInputs.map((input, index) => ({
      cto_name: input.ctoHead?.value || "",
      cost: input.ctoCost || "",
      year: currentYear,
      month: currentMonth,
      cto_type: input.type?.value || "",
      document_url: input.selectedFiles,
      status: "active",
      document: {},
      gym_id: selectedGym?.value
        ? selectedGym.value
        : selectedGymFromDropdown?.value,
    }));

    const payload = JSON.stringify({ cto_details: ctoDetails });
    handleCreateCTO(payload, decryptedText?.token);
  };

  const handleInputFileChange = (index, fileDataUrl) => {
    const updatedCtoDetails = [...formInputs];
    updatedCtoDetails[index].selectedFiles = fileDataUrl;
    setFormInputs(updatedCtoDetails);
  };

  const handleCreateCTO = async (formData, authToken) => {
    try {
      const result = await dispatch(createNewCTO({ formData, authToken }));

      if (createNewCTO.fulfilled.match(result)) {
        const successMessage = result.payload.message;
        setFormInputs(initialFormInputs);
        toast.success(successMessage);

        if (queryParameters) {
          dispatch(
            fetchCTOData({ queryParameters, token: decryptedText?.token })
          );
        }

        onClose();
      } else {
        const errorMessage = result.error.message;
        toast.error(errorMessage);
      }
    } catch (error) {
      console.log("handleCreateCTO ERROR => ", error);
    }
  };

  useEffect(() => {
    dispatch(fetchGymData(decryptedText?.token));
  }, []);

  useEffect(() => {
    dispatch(fetchCTOHead({ token: decryptedText?.token }));
  }, []);

  useEffect(() => {
    if (ctoHeadData?.status && ctoHeadData?.data) {
      const formattedCtoHeads = ctoHeadData.data.map((item) => ({
        value: item.head_name.toLowerCase().replace(/\s+/g, "_"),
        label: item.head_name,
      }));
      setAllCtoHeads(formattedCtoHeads);
    }
  }, [ctoHeadData]);

  useEffect(() => {
    if (userInfo?.isAuthenticated && userInfo?.user) {
      setDecryptedText(userInfo.user);
    }
  }, [userInfo]);

  return (
    <form className="formContainer settleForm createNewCtoFormContainer">
      <FormHeading title="Create New CTO" />

      {!selectedGym?.value && (
        <div className="formRow" style={{ marginBottom: "0" }}>
          <div className="formRowField">
            <label htmlFor="gym" className="formRowFieldLabel">
              Select Gym
            </label>

            <SelectDropdown
              options={gymData}
              selectedOption={selectedGymFromDropdown}
              setSelectedOption={(selectedValue) =>
                setSelectedGymFromDropdown(selectedValue)
              }
              name="Gym"
            />
          </div>
        </div>
      )}

      <div className="createNewFormInputsOuter">
        {formInputs.map((input, index) => (
          <div className="innerCreateNewFormInputsOuter" key={index}>
            {index > 0 && (
              <div className="removeButtonContainer">
                <button
                  className="removeButton"
                  onClick={(e) => removeInputs(e, index)}
                >
                  - Remove
                </button>
              </div>
            )}

            <div className="formInputs createNewFormInputs">
              <div className="formRow">
                <div className="formRowField">
                  <label
                    htmlFor={`cto-type-${index}`}
                    className="formRowFieldLabel"
                  >
                    CTO Type
                  </label>

                  <SelectDropdown
                    options={ctoTypes}
                    selectedOption={input.type}
                    setSelectedOption={(selectedValue) =>
                      handleInputChange(
                        index,
                        "type",
                        selectedValue,
                        decryptedText?.token
                      )
                    }
                    name="Type"
                  />
                </div>

                <div className="formRowField">
                  <label
                    htmlFor={`cto-head-${index}`}
                    className="formRowFieldLabel"
                  >
                    Select CTO Head
                  </label>

                  <SelectDropdown
                    options={allCtoHeads}
                    selectedOption={input?.ctoHead}
                    setSelectedOption={(selectedValue) =>
                      handleInputChange(
                        index,
                        "ctoHead",
                        selectedValue,
                        decryptedText?.token
                      )
                    }
                    name="From The List"
                  />
                </div>
              </div>

              <div className="formRow">
                <div className="formRowField">
                  <label
                    htmlFor={`cto-cost-${index}`}
                    className="formRowFieldLabel"
                  >
                    CTO Cost
                  </label>

                  <input
                    type="number"
                    placeholder="Enter CTO Cost"
                    className="formInput"
                    value={input.ctoCost}
                    onChange={(e) =>
                      handleInputChange(
                        index,
                        "ctoCost",
                        e.target.value,
                        decryptedText?.token
                      )
                    }
                  />
                </div>

                <div className="formRowField">
                  <label
                    htmlFor={`file-${index}`}
                    className="formRowFieldLabel"
                  >
                    Select document
                  </label>

                  <div className="chooseFilteInput">
                    <Form.Group controlId={`formFileLg-${index}`}>
                      <Form.Control
                        type="file"
                        onChange={(e) =>
                          handleInputChange(
                            index,
                            "file",
                            e.target.files[0],
                            decryptedText?.token
                          )
                        }
                      />
                    </Form.Group>
                  </div>
                </div>
              </div>
            </div>
          </div>
        ))}
      </div>

      <div className="addMoreButtonContainer">
        <button className="addMoreButton" onClick={addMoreInputs}>
          + ADD MORE
        </button>
      </div>

      <div className="formButtonContainer">
        <Button variant="danger" onClick={onSubmitCtoDetails}>
          Save
        </Button>
      </div>
    </form>
  );
}

export default CreateNewCTO;
